module.exports = __webpack_public_path__ + "static/media/homePage.2774b841.jpg";